import { memo } from 'react';

import styles from './IconButton.module.css';

type Props = {
  ariaControls?: string;
  ariaExpanded?: boolean;
  children: React.ReactNode;
  className?: string;
  label?: string;
  onClick: () => void;
};

function IconButtonComponent({ ariaControls, ariaExpanded, children, className = '', label, onClick }: Props) {
  return (
    <button
      aria-controls={ariaControls}
      aria-expanded={ariaExpanded}
      aria-label={label}
      className={`${styles.button} ${className}`}
      onClick={onClick}
      title={label}
    >
      {children}
    </button>
  );
}

export const IconButton = memo(IconButtonComponent);
